import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router';
import AppRoot from './common/AppRoot';
import './App.css';

const App = () => (
    <HelmetProvider>
        <CookiesProvider>
            <BrowserRouter>
                <AppRoot />
            </BrowserRouter>
        </CookiesProvider>
    </HelmetProvider>
);

export default App;
